import { setAddNewAsessment } from "../../../../../actions/manageVisitActions";

export function getToggles(dispatch, globalDispatch) {
  return {
    toggleAddNewAssessment: payload => globalDispatch(setAddNewAsessment(payload)),
  }
}